/**
 * @file
 * A JavaScript file for the theme.
 *
 * In order for this JavaScript to be loaded on pages, see the instructions in
 * the README.txt next to this file.
 */

// JavaScript should be made compatible with libraries other than jQuery by
// wrapping it with an "anonymous closure". See:
// - https://drupal.org/node/1446420
// - http://www.adequatelygood.com/2010/3/JavaScript-Module-Pattern-In-Depth
(function ($, Drupal, window, document) {
  'use strict';
  Drupal.behaviors.mobileNav = {
    attach: function (context, settings) {

      const menuSelector  = 'block-woar-theme-hauptnavigation';
      const brandingAfter = 'block-woar-theme-branding';
      const mobileId      = 'mobileNav';
      const mobileIdAfter = '.layout-container';
      const toggleId      = 'responsivemenuicon';
      const mql           = window.matchMedia('(max-width: 990px)');

      // Strip ids and classes
      const stripIdsAndClasses = ($root) => {
        const keep = [
          'menu',
          'menu-item',
          'menu-item--expanded',
          'menu-link',
          'first',
          'last',
        ]; // diese Klassen sollen bleiben

        $root.find('[id], [class], [hidden]')
          .addBack('[id], [class], [hidden]')
          .each(function () {
            // IDs immer löschen
            $(this).removeAttr('id hidden aria-hidden aria-expanded');

            // Klassen filtern
            const newClasses = ($(this).attr('class') || '')
              .split(/\s+/)
              .filter(cls => keep.includes(cls)) // nur erlaubte behalten
              .join(' ');

            if (newClasses) {
              $(this).attr('class', newClasses);
            } else {
              $(this).removeAttr('class');
            }
          });
      };

      // Debounce
      const debounce = (fn, ms = 150) => { let t; return (...a) => { clearTimeout(t); t = setTimeout(() => fn.apply(this, a), ms); }; };


      function buildNav() {
        if ($('#' + mobileId).length) return;

        const $srcMenu = $('#' + menuSelector);
        const $srcMenuUl = $srcMenu.find('ul.menu').first();

        const $cloneUl = $srcMenuUl.clone(false, false);
        stripIdsAndClasses($cloneUl);

        const $nav = $(`
          <nav id="${mobileId}" class="h-screen fixed inset-0 transition z-[9999] transform translate-x-full">
            <div class="mobileNav__panel h-full fixed right-0 top-0">
              <ul class="layer-depth-1"></ul>
            </div>
          </nav>
        `);

        // Insert desktop menu
        $nav.find('ul.layer-depth-1').replaceWith($cloneUl);

        // Define depths classes
        $nav.find('ul.menu').addClass('px-10 pt-20 border-box transform translate-x-full transition fixed h-full w-[300px] top-0 right-0');
        $nav.find('.mobileNav__panel > ul.menu').addClass('menu-layer-depth-1');
        $nav.find('ul.menu > .menu-item > ul.menu').addClass('menu-layer-depth-2');
        $nav.find('ul.menu > .menu-item > ul.menu > .menu-item > ul.menu').addClass('menu-layer-depth-3');
        $nav.find('ul.menu > .menu-item > ul.menu > .menu-item > ul.menu > .menu-item > ul.menu').addClass('menu-layer-depth-4');

        // Close-Button in panel
        $nav.prepend(
          '<button id="mobileNav-close" class="mobile-nav-close w-full cursor-pointer mt-5 pr-5 flex items-center justify-end relative z-10" aria-label="Menü schließen"><i class="fa-regular fa-circle-xmark" aria-hidden="true"></i><span class="text-small ml-2">Menü schließen</span></button>'
        );

        // Layer-Down Buttons an Expanded-Items
        $nav.find('ul.menu li.menu-item--expanded').each(function () {
          const $li  = $(this);
          const $a   = $li.children('a').last();
          const $ul  = $li.children('ul').first();
          const $btn = $('<button class="layer-down" aria-expanded="false" type="button"><i class="fa-solid fa-angle-right"></i></button>');
          if ($ul.length) { $ul.before($btn); $li.addClass('flex justify-between'); } else if ($a.length) { $a.after($btn); }
        });

        // Layer-Up Buttons in Submenus
        $nav.find('ul.menu ul.menu').prepend(
          '<button class="layer-up mb-5 flex items-center" type="button" aria-label="Zurück" aria-expanded="true"><i class="fa-solid fa-angle-left"></i><span class="text-small ml-2">zurück</span></button>'
        );

        $(mobileIdAfter).after($nav);

        if (!$('#' + toggleId).length) {
          $('.header-contact').after(
            `<div id="${toggleId}">
              <a href="#" class="nav-icon"><span></span><span></span><span></span></a>
            </div>`
          );
          $('#' + toggleId).hide();
        }
      }

      function openMobile() {
        const $nav = $('#' + mobileId);
        if (!$nav.length) return;

        $nav.find('ul.menu.menu-layer-depth-1').toggleClass('translate-x-0').toggleClass('translate-x-full');
        $('#' + mobileId).addClass('mobileNav-open');
        $('body').addClass('overflow-hidden');
        $('#' + mobileId).toggleClass('translate-x-0').toggleClass('translate-x-full');

        // Warten bis die Transition fertig ist
        $nav.one('transitionend', function(e) {
          if (e.originalEvent.propertyName === 'transform') {
            $nav.addClass('backdrop-blur-[4px] bg-black/35');
          }
        });
      }

      function closeMobile() {
        const $nav = $('#' + mobileId);
        if (!$nav.length) return;

        $nav.removeClass('backdrop-blur-[4px] bg-black/35');

        // Wenn die Blur-Transition fertig ist → Slide-Out starten
        $nav.one('transitionend', function(e) {
          if (e.originalEvent.propertyName === 'backdrop-filter') {
            $nav.find('ul.menu.menu-layer-depth-1').toggleClass('translate-x-0').toggleClass('translate-x-full');
            $('#' + mobileId).removeClass('mobileNav-open');
            $('body').removeClass('overflow-hidden');
            $('#' + mobileId).toggleClass('translate-x-0').toggleClass('translate-x-full');
          }
        });
      }

      function goDeeper($btn) {
        const $target = $btn.parent().find('> ul.menu');
        if ($target.length) $target.toggleClass('translate-x-0').toggleClass('translate-x-full');
      }

      function goUp($btn) {
        const $current = $btn.closest('ul.menu');
        $current.toggleClass('translate-x-0').toggleClass('translate-x-full');
      }

      function bindDesktopHover() {
        const sel = '#' + menuSelector + ' ul > li.menu-item--expanded';
        $(sel).off('.desktopMenu')
          .on('mouseenter.desktopMenu focusin.desktopMenu', function () {
            $(this).children('ul').stop(true, true).fadeIn('fast').removeAttr('hidden');
            $(this).children('a').attr('aria-expanded', 'true');
          })
          .on('mouseleave.desktopMenu focusout.desktopMenu', function () {
            $(this).children('ul').stop(true, true).fadeOut('fast').attr('hidden', true);
            $(this).children('a').attr('aria-expanded', 'false');
          });

        $('#' + menuSelector + ' li.menu-item--expanded > a').each(function () {
          this.setAttribute('aria-haspopup', 'true');
          this.setAttribute('aria-expanded', 'false');
        }).off('keydown.desktopMenu').on('keydown.desktopMenu', function (e) {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            const submenu = this.nextElementSibling;
            const expanded = this.getAttribute('aria-expanded') === 'true';
            this.setAttribute('aria-expanded', (!expanded).toString());
            if (submenu && submenu.tagName === 'UL') submenu.hidden = expanded;
          }
        });
      }


      // Switch desktop/mobile
      function switchMode() {
        if (mql.matches) {
          buildNav();
          $('#' + toggleId).show();
          $('#' + menuSelector).hide();
        } else {
          $('#' + mobileId).remove();
          $('#' + toggleId).hide();
          $('#' + menuSelector).show();
          bindDesktopHover();
        }
      };



      // Events (einmalig)
      once('mobile-offcanvas-init', 'html', context).forEach(() => {

        $(document).on('click', '#' + toggleId, function (e) {
          e.preventDefault();
          const $nav = $('#' + mobileId);
          if (!$nav.hasClass('mobileNav-open')) openMobile(); else closeMobile();
          // if ($nav.hasClass('hidden')) openMobile(); else closeMobile();
        });

        // Close
        $(document).on('click', '#mobileNav-close', function () {
          closeMobile();
        });

        // Layer down/up
        $(document).on('click keydown', '#' + mobileId + ' .layer-down', function (e) {
          if (e.type === 'keydown' && e.key !== 'Enter' && e.key !== ' ') return;
          goDeeper($(this));
        });
        $(document).on('click', '#' + mobileId + ' .layer-up', function () {
          goUp($(this));
        });

        // Links schließen Menü
        $(document).on('click', '#' + mobileId + ' .menu a', function () {
          closeMobile();
        });

        // ESC schließt
        $(document).on('keydown', function (e) {
          if (e.key === 'Escape') closeMobile();
        });

        switchMode();
        (mql.addEventListener ? mql.addEventListener('change', switchMode) : mql.addListener(switchMode));
        $(window).on('resize.mobileOffCanvas', debounce(switchMode, 150));
      });
    }
  };
})(jQuery, Drupal, window, document);
